import React, { useRef, useState, useEffect } from 'react';
import SunEditor from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css';
import '../css/editor.css';
import '../css/wa.css';
import { fetchUserData } from '../api/getUserData';
import { publishPost } from '../api/postApi'; // Assume you'll create this API function
import axios from "axios";


import { useToast } from "../components/ToastProvider";
import { select } from 'slate';


const MonthlyEditor = () => {
    const [input, setInput] = useState('');
    const [title, setTitle] = useState('');
    const inputRef = useRef(null);
    const editorRef = useRef();
    const [editorData, setEditorData] = useState('');
    const showToast = useToast();
    const [isAdmin, setIsAdmin] = useState(false);

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) {
            window.location.href = '/login';
            showToast("로그인 후 사용할 수 있는 기능입니다.", { type: "warn" })
        } else {
            
            const getAdminData = async () => {
                const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/isAdmin`, { token });
                setIsAdmin(data.isAdmin);
                if (!data.isAdmin) {
                    window.location.href = "/";
                }
            };
            getAdminData();
        }
    }, []);

    // Existing tag-related functions (handleInputChange, handleKeyDown, removeTag)

    const handleEditorChange = (content) => {
        setEditorData(content);
    };

    // New publication handler
    
    const handlePublish = async () => {
        // Validation checks
        if (!title.trim()) {
            alert('제목을 입력해주세요.');
            return;
        }
    
        try {
            const token = localStorage.getItem('token');
            const postData = {
                title: title,
                content: editorData
            };
    
            const response = await axios.post('http://localhost:5555/monthly/publish', postData, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
    
            if (response.data && response.data.articleId) {
                // Redirect to the newly created post
                window.location.href = `/community/article/${response.data.articleId}`;
            } else {
                alert('글 발행에 실패했습니다. 다시 시도해주세요.');
            }
        } catch (error) {
            console.error('Publication error:', error);
    
            if (error.response && error.response.status === 401) {
                alert('로그인이 필요합니다. 로그인 페이지로 이동합니다.');
                window.location.href = '/login';
            } else {
                alert('글 발행 중 오류가 발생했습니다.');
            }
        }
    };
    

    return (
        <>
            <h1>월간지 작성하기</h1>
            <div className="ed-flex">
                <div className="ed-main-area">
                    <div className="ed-main-editor">
                        <SunEditor
                            onChange={handleEditorChange}
                            mode="inline"
                            lang="ko"
                            setContents={editorData}
                            placeholder="여기에 내용을 입력해주세요..."
                            setOptions={{
                                height: '700px',
                                minHeight: '700px',
                                placeholder: '여기에 내용을 입력해주세요...',
                                buttonList: [
                                    ['undo', 'redo'],
                                    ['font', 'fontSize', 'formatBlock'],
                                    ['bold', 'italic', 'underline', 'strike', 'subscript', 'superscript', 'fontColor', 'hiliteColor', 'textStyle'],
                                    ['align', 'horizontalRule', 'list', 'lineHeight'],
                                    ['outdent', 'indent'],
                                    ['table', 'link', 'image', 'video'],
                                    ['blockquote', 'codeView', 'preview', 'print'],
                                    ['fullScreen', 'showBlocks', 'codeView'],
                                ],
                                font: ['Wanted Sans', 'Arial', 'Comic Sans MS', 'Courier New', 'Georgia', 'Tahoma', 'Verdana'],
                                fontSize: [8, 10, 12, 14, 16, 18, 20, 24, 28, 32, 36],
                                defaultStyle: 'font-size: 16px; font-family: Arial, sans-serif;',


                            }}
                        />
                    </div>
                </div>
                <div className="ed-side">
                    <div className="wa-card ed-side-tool">
                        <div className="ed-publish-ct">
                            <input
                                type="text"
                                placeholder="제목을 입력하세요"
                                className="ed-title"
                                value={title}
                                onChange={(e) => setTitle(e.target.value)}
                            />


                            <button 
                                className="ed-publish" 
                                onClick={handlePublish}
                            >
                                발행하기
                            </button>
                        </div>
                    </div>
                    
                    {/* Temporary Save Section */}
                    
                </div>
            </div>
        </>
    );
};

export default MonthlyEditor;